import { FhirBundleSdk } from "@metriport/fhir-sdk";
import { getDiagnosticReportRows } from "./diagnostic-reports-rows";
import { getImagingReportRows } from "./imaging-reports-rows";

export const diagnosticReportMetadata = {
  tableType: "DiagnosticReport",
  displayName: "Notes",
  getRows: (bundle: FhirBundleSdk) => getDiagnosticReportRows({ bundle }),
  getSearchableText: (row: Record<string, unknown>) => {
    // Extract all row values except metadata
    const rowValues = Object.entries(row)
      .filter(([key]) => key !== "originalData" && key !== "id" && key !== "noteData")
      .map(([, value]) => String(value ?? ""))
      .join(" ");

    // Include note full text if available
    const noteData = row.noteData as { fullText?: string } | undefined;
    const noteText = noteData?.fullText ?? "";

    return (rowValues + " " + noteText).toLowerCase();
  },
};

export const imagingReportMetadata = {
  tableType: "ImagingReports",
  displayName: "Imaging",
  getRows: (bundle: FhirBundleSdk) => getImagingReportRows({ bundle }),
  getSearchableText: (row: Record<string, unknown>) => {
    // Extract all row values except metadata
    const rowValues = Object.entries(row)
      .filter(([key]) => key !== "originalData" && key !== "id" && key !== "noteData")
      .map(([, value]) => String(value ?? ""))
      .join(" ");

    // Include note full text if available
    const noteData = row.noteData as { fullText?: string } | undefined;
    const noteText = noteData?.fullText ?? "";

    return (rowValues + " " + noteText).toLowerCase();
  },
};
